'use client'

import { memo } from 'react'

import { ErrorDataUnavailable } from '@/components/common/Error'

const ChartCollateralAtRiskError = () => {
  return <ErrorDataUnavailable minHeight="358px" />
}

export default memo(ChartCollateralAtRiskError)
